// Spec 084 — o código legível da batelada.
//
// A GERAÇÃO é do banco (trigger `production_run_batch_code`, `23_batch_traceability.sql`): são quatro
// portas que criam execução, e uma esquecida produziria batelada sem nome. Aqui ficam só o formato
// gerado e a regra do código que o gestor pode digitar no lugar (FR-013).

/** `AAAAMMDD-NN`, com a sequência crescendo para três dígitos depois de 99. */
export const GENERATED_BATCH_CODE_PATTERN = /^\d{8}-\d{2,}$/;

/** O que o gestor pode digitar: sem espaço, sem barra, até 40 caracteres. */
export const BATCH_CODE_PATTERN = /^[A-Za-z0-9._-]{1,40}$/;

export function isGeneratedBatchCode(code: string): boolean {
  return GENERATED_BATCH_CODE_PATTERN.test(code);
}

/** Como a batelada aparece fora da própria linha: "Etapa 1 · 20260915-02". */
export function batchLabel(lineName: string, batchCode: string): string {
  return `${lineName} · ${batchCode}`;
}
